module.exports = __webpack_public_path__ + "static/media/section-1@2x.e3a8e7c0.png";